import { useEffect, useRef } from "react";
import Message from "./Message";

const MessageList = ({ messages, isLoading, backendContext }) => {
  const messagesEndRef = useRef(null);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, isLoading]);

  return (
    <div className="chat-message-container">
      {/* Empty state */}
      {messages.length === 0 && !isLoading && (
        <div className="chat-empty-state">
          <div className="chat-empty-icon">💻</div>
          <h3 className="chat-empty-title monika-title">Ask about the Monika codebase</h3>
          <p className="chat-empty-subtitle">
            {backendContext
              ? `Full context loaded: ${backendContext.metadata.totalFiles} files analyzed`
              : "Context unavailable"}
          </p>
        </div>
      )}

      {/* Messages - Clean T3-style structure */}
      {messages.map((message, index) => (
        <Message
          key={index}
          message={message}
          timestamp={new Date().toLocaleTimeString()}
          isLast={index === messages.length - 1}
        />
      ))}

      {/* Loading indicator */}
      {isLoading && (
        <div className="chat-loading-wrapper">
          <div className="chat-loading-bubble">
            <div className="chat-loading-dots"></div>
            <span className="chat-loading-text">
              {backendContext ? "Analyzing with full context..." : "Analyzing code..."}
            </span>
          </div>
        </div>
      )}

      <div ref={messagesEndRef} />
    </div>
  );
};

export default MessageList;
